module.exports = __webpack_public_path__ + "static/media/00030600.6a561fdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/galery/00030600.jpg
// module id = 128
// module chunks = 0